

















































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  downloadfile,
  downloadpdf,
  downloadZip,
  downloadJieTiZip,
} from "@/api/declare";
import {
  gettpoiclist,
  getExpertNum,
  getRandomList,
  addExperts,
  getExpertsList,
  getExpertReview,
} from "@/api/tissuemanage";
import { getAccessorysByTopicId } from "@/api/laddermanage";
import { getdatalist } from "@/api/expertTank";
import Pagination from "@/components/Pagination/index.vue";
import moment from "moment";
import { saveOrUpdate, getOptionInfo } from "@/api/proofSheet";
import router from "@/router";
@Component({
  name: "guideManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.apiurl = (window as any).baseurl;
    console.log("route.path", this.$route.path);
    if (this.$route.path === "/expertLadderManage/expertLadderManage2") {
      this.typeidentifier = 2;
      this.stateoptions = [
        {
          label: "待审核",
          value: "17",
        },
        {
          label: "已审核",
          value: "18",
        },
      ];
      console.log("typeidentifier", this.typeidentifier);
    }
    this.getList(this.listQuery);
    this.getYearList();
    this.baseurl = (window as any).downloadurl;
    this.listQuery.userid = window.sessionStorage.getItem("id");
    this.listQuery.role = Number(window.sessionStorage.getItem("role"));
  }
  @Watch("ruleForm.score")
  public onShowChange(value: string) {
    console.log(value);
    if (value <= "60") {
      this.ruleForm.level = "D";
    } else if (value <= "74") {
      this.ruleForm.level = "C";
    } else if (value <= "84") {
      this.ruleForm.level = "B";
    } else if (value <= "100") {
      this.ruleForm.level = "A";
    }
  }
  public typeidentifier: number = 1;
  private year = null; // 年度
  private yearlist: any[] = [];
  public currtentpage = 1;
  public baseurl = "";
  public total: number = 0;
  public topicrole = "";
  public shstate = "";
  public selectVal = "";
  public isShowBtn = true;
  public expertQuery: any = {
    pageNum: 1,
    pageSize: 10,
    param: "",
    randomNum: 0,
    topicIds: [],
  };
  // 上传审批意见的参数
  public ruleForm = {
    option: "该课题建议定级为：（A级/B级/C级/D级）\n" + "理由如下：",
    score: 0,
    level: "D",
    visible: false,
    topicId: "",
  };

  // 综合评审请求参数
  public expertcomQuery = {
    name: "",
    page: 1,
    limit: 10,
  };
  public formObj: any = {
    title: "",
    expertVis: false,
    number: "", // 选中的人数
    addExoertVis: false, // 添加评审专家模态框
    searcVal: "", // 添加评审专家查询名称
    expertList: [], // 专家数组
    tableData: [], // 添加评审专家数据源
    total: 0,
    currentPage: 1,
    multipleSelection: [], // 添加专家页面复选多个数据
    comExpertVis: false, // 指定综合评审专家
    addcomExoertVis: false, // 指定专家评审页面
    comTableData: [],
    topicId: "", // 课题id
  };
  public zjhzForm: any = {
    visible: false,
    maxNum: 0,
    minNum: 0,
    average: 0,
    level: "",
    infoList: [],
  };
  // 选择人数下拉框
  public options = [
    {
      value: "1",
      label: "1",
    },
    {
      value: "2",
      label: "2",
    },
    {
      value: "3",
      label: "3",
    },
    {
      value: "4",
      label: "4",
    },
    {
      value: "5",
      label: "5",
    },
  ];
  public usestate = [
    {
      value: 1,
      label: "启用",
    },
    {
      value: 0,
      label: "禁用",
    },
  ];
  public roleoptions = [
    {
      label: "中心选题",
      value: 0,
    },
    {
      label: "自主选题",
      value: 1,
    },
  ];
  public scoreRules = {
    option: [{ required: true, message: "请输入评分意见", trigger: "blur" }],
    score: [{ required: true, message: "请输入评分", trigger: "blur" }],
  };
  public stateoptions = [
    {
      label: "待审核",
      value: "15",
    },
    {
      label: "已审核",
      value: "16",
    },
  ];
  public tableData: any = [];
  public name = "";
  public isloading = true;
  public listQuery: any = {
    level: -1,
    limit: 10,
    name: "",
    num: "",
    page: 1,
    state: -1,
    topictype: -1,
    userid: "",
    role: 0,
    expertRole: "",
  };
  // 表单校验规则
  public rules = {
    name: [
      { required: true, message: "请输入组织名称", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    description: [
      { required: true, message: "请输入备注内容", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    number: [{ required: true, message: "请输入组织编号", trigger: "change" }],
  };

  throttle(func, delay) {
    let timer = null as any;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  // 将scoreChange定义为类的属性，在构造函数中初始化
  private scoreChange: (val: any, row: any) => void;

  // 在构造函数中初始化带节流的scoreChange
  constructor() {
    super(); // 如果是继承的类需要调用super()
    const _this = this;
    this.scoreChange = this.throttle(async function (val, row) {
      console.log(val);
      console.log(row);
      console.log(_this.$route.path);
      const param = {
        isOnlyScore: true,
        opinion: "该课题建议定级为：（A级/B级/C级/D级）\n" + "理由如下：",
        score: Number(val),
        topicId: row.id,
        userId: window.sessionStorage.getItem("id"),
        typeidentifier: this.$route.path.includes("expertLadderManage2")
          ? 2
          : 1,
      };
      await saveOrUpdate(param);
      this.getList(this.listQuery);
    }, 100);
  }

  // 获取列表
  public async getList(params: any) {
    // 限制搜索范围
    params["typeidentifier"] = this.typeidentifier;
    if (this.typeidentifier == 1) {
      params["stateList"] = [13, 15, 16, 20];
    } else if (this.typeidentifier == 2) {
      params["stateList"] = [14, 17, 18, 19, 21];
    }
    console.log(params);
    await gettpoiclist(params)
      .then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.itemBeanList[0];
          this.total = res.data.total;
          this.isloading = false;
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      });
  }
  public cleardata() {
    this.listQuery.state = -1;
    this.getList(this.listQuery);
  }
  public prints(item) {
    let prints: any = document.getElementById("maincard");
    prints.title = item.name;
  }
  async changestate(val) {
    if (val == null) {
      this.listQuery.state = -1;
    } else {
      this.listQuery.state = val;
    }
    await gettpoiclist(this.listQuery).then((res) => {
      if (res.code === 200) {
        let copeData = res.data.itemBeanList[0];
        this.total = res.data.total;
        this.tableData = [];
        this.isloading = false;
        if (val === "-2") {
          copeData.forEach((res: any) => {
            if (res.average === null) {
              this.tableData.push(res);
            }
          });
        } else {
          this.tableData = res.data.itemBeanList[0];
        }
      }
    });
  }
  public changerole(val) {
    if (val === "") {
      this.listQuery.topictype = -1;
    } else {
      this.listQuery.topictype = val;
    }
    this.getList(this.listQuery);
  }
  public onSubmit() {
    this.listQuery.page = 1;
    this.listQuery.name = this.name;
    // listQuery.state = -2的时候 返回专家评审完成的数据和专家评审中的数据 页面只显示专家评审中的数据
    if (this.listQuery.state === "-2") {
      this.changestate(this.listQuery.state);
    } else {
      this.getList(this.listQuery);
    }
  }
  public clearSearch() {
    this.listQuery = {
      expertRole: "",
      role: 3,
      level: -1,
      limit: 10,
      name: "",
      num: "",
      page: 1,
      state: -1,
      topictype: -1,
      userid: window.sessionStorage.getItem("id"),
    };
    this.name = "";
    this.topicrole = "";
    this.shstate = "";
    this.getList(this.listQuery);
  }
  // public watchitem(params, row) {
  //   this.$router.push({ path: "/declare/declare" });
  //   let topicinfo: any = JSON.stringify(row);
  //   window.sessionStorage.setItem("topicid", JSON.stringify(params));
  //   window.sessionStorage.setItem("iswatch", "true");
  //   window.sessionStorage.setItem("ishandle", "true");
  //   window.sessionStorage.setItem("topicinfo", topicinfo);
  //   let time = row.createtime.substring(0, 4);
  //   window.sessionStorage.setItem("time", time);
  // }

  public watchitem(params, row) {
    let topicinfo: any = JSON.stringify(row);
    window.sessionStorage.setItem(
      "topicid",
      JSON.stringify({ topicId: params })
    );
    window.sessionStorage.setItem("iswatch", "false");
    window.sessionStorage.setItem("ishandle", "true");
    window.sessionStorage.setItem("topicinfo", topicinfo);
    let time = row.createtime.substring(0, 4);
    window.sessionStorage.setItem("time", time);
    if (row.isrefuse == 1) {
      window.sessionStorage.setItem("isrefuse", "true");
    } else {
      window.sessionStorage.removeItem("isrefuse");
    }
    // this.$router.push({ path: "/ladder/ladder" });
    const { href } = this.$router.resolve({ path: "/ladder/ladder" });
    window.open(href, "_blank");
  }

  public async editLineItem(params: any) {
    this.ruleForm.visible = true;
    this.isShowBtn = true;
    this.ruleForm.topicId = params.id;
    let param = {
      topicId: params.id,
      userId: window.sessionStorage.getItem("id"),
      typeidentifier: this.typeidentifier,
    };
    getOptionInfo(param).then((res) => {
      if (res.code === 200) {
        this.ruleForm.score = res.data.score;
        if (res.data.opinion === null) {
          this.ruleForm.option =
            "该课题建议定级为：（A级/B级/C级/D级）\n" + "理由如下：";
        } else {
          this.ruleForm.option = res.data.opinion;
        }
      }
    });
  }
  closeComExpert() {
    this.zjhzForm.visible = false;
  }
  watchResult(val) {
    this.isShowBtn = false;
    let parma = {
      topicId: val,
      userId: window.sessionStorage.getItem("id"),
      typeidentifier: this.typeidentifier,
    };
    getOptionInfo(parma).then((res) => {
      if (res.code === 200) {
        this.ruleForm.visible = true;
        this.isShowBtn = false;
        this.ruleForm.score = res.data.score;
        this.ruleForm.option = res.data.opinion;
      }
    });
  }
  loadNumber(val) {
    console.log(val);
    // var elValue = val
    // var reg = /^((?!0)\d{1,2})$/;
    // if (!reg.test(elValue)) {
    //   val = ''
    // }
    // return val
  }
  // 查看线上pdf
  WatchLineItem(id, row) {
    let sbdata: any = {}; // 申报对象集合
    let param = {
      id: id,
    };

    downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data;
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res;
          }
        });
        if (sbdata.state === 0) {
          this.$message.warning("申报表暂未生成，请生成后查看");
        } else if (sbdata.state === 1) {
          this.$message.warning("申报表正在生成中,请稍后查看");
        } else {
          let href_ = "/pdf/" + sbdata.url.split(",").pop();
          const { href } = this.$router.resolve({
            path: "/proofSheet",
            query: { url: href_ },
          });
          // this.$router.push('/proofSheet')
          window.open(href);
        }
      }
    });
  }
  editLineBotItem(params: any, row: any) {
    let topicinfo: any = JSON.stringify(row);
    window.sessionStorage.setItem("topicid", JSON.stringify(params));
    window.sessionStorage.setItem("iswatch", "true");
    window.sessionStorage.setItem("topicinfo", topicinfo);
    window.sessionStorage.removeItem("ishandle");
    let time = row.createtime.substring(0, 4);
    window.sessionStorage.setItem("time", time);
    // isrefuse=1的时候是预算驳回后重新上传的状态 declare页面显示预算驳回后的表格
    if (row.isrefuse === 1) {
      window.sessionStorage.setItem("isrefuse", "true");
    } else {
      window.sessionStorage.removeItem("isrefuse");
    }
    // const { href } = this.$router.resolve({ path: "/declare/declare" });
    // window.open(href, "_blank");
    this.$router.push({ path: "/expertLine/expertLine" });
  }

  // async downloadFileFetch(param) {
  //   try {
  //     this.isloading = true
  //     let url = `${this.apiurl}/pdfstate/getTopicFile?id=${param.id}&typeidentifier=${param.typeidentifier}`
  //     const response = await fetch(url, {
  //       method: 'GET'
  //     })

  //     if (response.status == 204) {
  //       this.$message.error('下载文件失败，请检查文件是否存在')
  //       return
  //     }

  //     const contentType = response.headers.get('content-type')
  //     console.log('response', response)

  //     if (contentType && contentType.includes('application/json')) {
  //     // 如果是 JSON，直接解析并报警
  //       return response.json().then((err) => {
  //         this.$message.error('下载文件失败，请检查文件是否存在')
  //       })
  //     }

  //     // 如果是文件流，获取 Blob
  //     let blob = await response.blob()
  //     if (!blob) return

  //     console.log('blob', blob)

  //     // 3. 处理下载
  //     const downurl = window.URL.createObjectURL(blob)
  //     const a = document.createElement('a')
  //     a.href = downurl

  //     const disposition = response.headers.get('Content-Disposition')
  //     console.log('disposition', disposition)
  //     if (disposition) {
  //       // 匹配后端返回的 filename（兼容不同格式）
  //       const match = disposition.match(/filename="?([^";]+)"?/)
  //       if (match && match[1]) {
  //         a.download = decodeURIComponent(match[1])
  //       }
  //     }

  //     document.body.appendChild(a)
  //     a.click()
  //     window.URL.revokeObjectURL(url)
  //     document.body.removeChild(a)
  //   } catch (error) {
  //     this.$message.error('下载文件失败，请检查文件是否存在')
  //   } finally {
  //     this.isloading = false
  //   }
  // }
  // 公共下载逻辑
  private async downloadCommon(url, fileNameStr = "文件", isAddData = true) {
    try {
      this.isloading = true;
      const response = await fetch(url, {
        method: "GET",
      });

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需+1并补0
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      // 从响应头读取后端设置的文件名
      const disposition = response.headers.get("Content-Disposition");
      let fileName = ""; // 初始文件名
      if (isAddData) {
        fileName = `${year}${month}${day}${hours}${minutes} ${fileNameStr}`;
      } else {
        fileName = fileNameStr;
      }

      if (disposition) {
        // 匹配后端返回的 filename（兼容不同格式）
        const match = disposition.match(/filename="?([^";]+)"?/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }

      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl); // 释放内存
    } catch (error) {
      this.$message.error("下载文件失败，请稍后重试");
    } finally {
      this.isloading = false;
    }
  }

  downfile(type_, row) {
    let param = {
      topicid: row.id,
      typeidentifier: -1,
    };
    let sbdata: any = {}; // 申报对象集合
    let ysdaya: any = {}; // 预算对象集合
    let jddata = {
      filepath: "",
      filename: "",
    };
    if (type_ === 3) {
      param.typeidentifier = 0;
      // this.downloadFileFetch(param)
    } else if (type_ === 4) {
      param.typeidentifier = 1;
      // this.downloadFileFetch(param)
    }
    if (param.typeidentifier != -1) {
      getAccessorysByTopicId(param).then((res) => {
        console.log("Topicladders", res, row);
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            let _d = res.data[0];
            if (!_d.filepath) {
              this.$message.warning("报告暂未生成，请先生成后下载");
              return;
            }
            let href =
              this.apiurl +
              "topicdatadetail/downLoadFile?filepath=" +
              _d.filepath +
              "&filename=" +
              _d.filename;
            // console.log('href', href)
            this.downloadCommon(
              href,
              row.name +
                (param.typeidentifier === 0 ? " 阶段报告" : " 结题报告") +
                _d.filepath.slice(_d.filepath.lastIndexOf(".")),
              false
            );
          }
        }
      });
    }
  }
  watchfile(type_, row) {
    let param = {
      id: row.id,
    };
    let sbdata: any = {}; // 申报对象集合
    let ysdaya: any = {}; // 预算对象集合
    downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data;
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res;
          } else {
            ysdaya = res;
          }
        });
        if (type_ === 0) {
          if (sbdata.state === 0) {
            this.$message.warning("申报表暂未生成，请先生成后下载");
          } else if (sbdata.state === 1) {
            this.$message.warning("申报表正在生成中,请稍后下载");
          } else {
            var x = new XMLHttpRequest();
            let href = this.baseurl + "pdf/" + sbdata.url;
            x.open("GET", href, true);
            x.responseType = "blob";
            x.onload = function (e) {
              var url = window.URL.createObjectURL(x.response);
              var a = document.createElement("a");
              a.href = url;
              a.target = "_blank";
              // if (row.name == null) {
              //   a.download = "申报表";
              // } else {
              //   a.download = row.name + "申报表";
              // }
              a.click();
            };
            x.send();
          }
        } else {
          if (ysdaya.state === 0) {
            this.$message.warning("预算表暂未生成，请先生成后下载");
          } else if (ysdaya.state === 1) {
            this.$message.warning("预算表正在生成中,请稍后下载");
          } else {
            let href = this.baseurl + "/pdf/" + ysdaya.url;
            let url = window.URL.createObjectURL(href);
            const savea = document.createElement("a");
            savea.download = "sss";
            if (row.name == null) {
              savea.download = "预算表";
            } else {
              savea.download = row.name + "预算表";
            }
            savea.href = url;
            savea.click();
          }
        }
      }
    });
  }
  public handleClose() {
    this.formObj.expertVis = false;
    this.ruleForm.visible = false;
  }
  // andy 增加年度查询条件
  private clearyear() {
    this.listQuery.year = null;
    this.getList(this.listQuery);
  }
  private changeyear(val) {
    if (val != null) {
      this.listQuery.year = val;
    }
    this.getList(this.listQuery);
  }
  // 分页
  public handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getList(this.listQuery);
  }
  public handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getList(this.listQuery);
  }
  public expertSizeChange(val) {
    this.expertQuery.pageSize = val;
    this.getExpertList(this.expertQuery);
  }
  public expertCurrentChange(val) {
    this.expertQuery.pageNum = val;
    this.getExpertList(this.expertQuery);
  }
  public expertcomSize(val) {
    this.expertcomQuery.limit = val;
  }
  public expertcomPage(val) {
    this.expertcomQuery.page = val;
  }
  public cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  public rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
  // 指定专家模态框
  public giveExperst(val) {
    this.formObj.expertVis = true;
    this.selectVal = "";
    this.formObj.title = "指定评审专家";
    this.formObj.topicId = val.id;
    let param: any = {
      type: 1, // 1线上专家 2线下专家
      topicIds: [],
    };
    param.topicIds.push(this.formObj.topicId);
    getExpertsList(param).then((res) => {
      this.formObj.expertList = res.data;
    });
  }
  // 指定专家组长
  public giveLeader() {
    this.zjhzForm.visible = true;
    this.formObj.title = "指定专家组长";
  }
  // 随机抽取人数
  choosePerson() {
    let param: any = {
      pageNum: 1,
      pageSize: 10,
      param: "",
      topicIds: [],
    };
    param.randomNum = Number(this.selectVal);
    param.topicIds.push(this.formObj.topicId);
    getRandomList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.expertList = this.formObj.expertList.concat(res.data);
        let newObj = {};
        this.formObj.expertList = this.formObj.expertList.reduce(
          (cur, next) => {
            newObj[next.id] ? "" : (newObj[next.id] = true && cur.push(next));
            return cur;
          },
          []
        );
      } else if (res.code === 417) {
        this.$message.warning(res.message);
      }
    });
  }
  // 提交分数的页面
  submitForm() {
    (this.$refs.agreeform as any).validate((valid) => {
      if (valid) {
        let param: any = {
          opinion: this.ruleForm.option,
          score: Number(this.ruleForm.score),
          topicId: this.ruleForm.topicId,
          userId: window.sessionStorage.getItem("id"),
          typeidentifier: this.typeidentifier,
        };
        if (param.score <= 0) {
          this.$message.error("请给出评分");
          return;
        }
        saveOrUpdate(param).then((res) => {
          if (res.code === 200) {
            this.$message.success("专家意见保存成功");
            this.ruleForm.visible = false;
            this.getList(this.listQuery);
          }
        });
      } else {
        return false;
      }
    });
  }
  // 添加评审专家
  addPerson() {
    this.formObj.addExoertVis = true;
    this.formObj.title = "添加评审专家";
    this.expertQuery.topicIds.push(this.formObj.topicId);
    this.getExpertList(this.expertQuery);
  }
  // 指定线上专家 查询列表
  getExpertList(val) {
    getdatalist(val).then((res) => {
      if (res.code === 200) {
        this.formObj.tableData = res.data.records;
        this.formObj.total = res.data.total;
      }
    });
  }
  // 从指定综合评审专家进入的添加评审专家
  addcomPerson() {
    this.formObj.addExoertVis = true;
    getdatalist(this.expertcomQuery).then((res) => {
      if (res.code === 200) {
        this.formObj.comTableData = res.data.list;
        this.formObj.total = res.data.total;
      }
    });
  }
  // 提交专家
  submitExperts() {
    let param: any = [];
    let obj: any = {
      expertIds: [],
      topicId: this.formObj.topicId,
      type: 1,
    };
    this.formObj.expertList.forEach((res) => {
      obj.expertIds.push(res.id);
    });
    param.push(obj);
    addExperts(param).then((res) => {
      if (res.code === 200) {
        this.$message.success("课题绑定线上专家成功");
        this.formObj.expertVis = false;
      }
    });
  }
  // 提交选择专家
  submitchooseExperts() {
    this.formObj.expertList = this.formObj.expertList.concat(
      this.formObj.multipleSelection
    );
    let newObj = {};
    this.formObj.expertList = this.formObj.expertList.reduce((cur, next) => {
      newObj[next.id] ? "" : (newObj[next.id] = true && cur.push(next));
      return cur;
    }, []);
    this.formObj.addExoertVis = false;
    this.formObj.title = "指定评审专家";
  }
  expertSize(val) {
    this.expertQuery.limit = val;
    this.addPerson();
  }
  expertPage(val) {
    this.expertQuery.page = val;
    this.addPerson();
  }
  // 添加专家复选框
  handleSelectionChange(val) {
    val.forEach((res) => {
      let obj: any = {
        id: res.id,
        employer: res.employer,
        name: res.name,
      };
      this.formObj.multipleSelection.push(obj);
    });
  }
  closeExperts() {
    this.formObj.addExoertVis = false;
  }
  // 删除指定专家
  removeChoose(index) {
    this.formObj.expertList.splice(index, 1);
    this.searcVal = String(this.formObj.expertList.length);
  }
  // 查询专家评审汇总
  getExpertScore(val) {
    this.zjhzForm.visible = true;
    this.zjhzForm.infoList = [];
    let param = {
      topicId: val.id,
    };
    getExpertReview(param).then((res) => {
      if (res.code === 200) {
        this.zjhzForm.maxNum = res.data.maxScore;
        this.zjhzForm.minNum = res.data.minScore;
        this.zjhzForm.average = res.data.average;
        this.zjhzForm.name = val.name;
        this.zjhzForm.topicUser = val.headname;
        res.data.infoList.forEach((res) => {
          if (res.score !== null && res.idea !== null) {
            this.zjhzForm.infoList.push(res);
          }
        });
      }
    });
  }
  claseZjhz() {
    this.zjhzForm.visible = false;
  }
  // 上传文件
  uploadPzfile() {}

  getYearList() {
    let d = new Date();
    let year = d.getFullYear();
    for (let index = 2021; index <= year; index++) {
      this.yearlist.unshift(index);
    }
  }
}
